import { VFC } from "react";
import { useTranslation } from "~/hooks";
import { SEO, PageHeader } from "~/components";
import { About } from "~/layouts";

const AboutPage: VFC = () => {
  const { dic } = useTranslation();
  return (
    <About>
      <SEO pageName="私たちについて" path="/about" />
      <PageHeader
        labelText="About"
        headingText={dic.navigation.about}
        crumbs={[
          {
            label: dic.homepage,
            path: "/"
          },
          {
            label: dic.navigation.about
          }
        ]}
      />
      <About.Story />
      <About.Profile />
      <About.Greeting />
      <About.Images />
    </About>
  );
};

export default AboutPage;
